<template>
  <div class="grid-view">
    <div class="main-content">
      <!--按钮-->
      <div style="margin-top: 5px">
        <el-button v-if="isEdit" type="primary" no="Cancel" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        <el-button v-if="isEdit" type="primary" no="Save" @click="save">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button v-if="!isEdit" type="primary" no="Back" @click="$emit('back')">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
        <el-button v-if="!isEdit && editShow && source === 'CarFormTab'" type="primary" no="Edit" @click="edit">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
      </div>
      <!--车单基本信息-->
      <el-form :disabled="!isEdit" class="car-form-detail-form" style="margin-top: 5px;background-color: #f0f3f8;padding: 5px" :label-width="$selectByLang('100px', '140px')" label-position="left">
        <el-row>
          <el-col :span="6">
            <!--车单编号-->
            <el-form-item :label="$t('CargoMsg.Cargo_VehicleOrderNo')">
              <el-input
                v-model="form.carFormNo"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--车队-->
            <el-form-item :label="$t('CargoMsg.Cargo_Motorcade')">
              <cargo-company-select
                no="carryingCmp"
                clearable
                filterable
                :method-params="{truckCmp:true,active:true}"
                :default-value="form.carryingCmp||0"
                @change="p=>{form.carryingCmp=p.value||0;carryingCmpChangeHandler()}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--司机-->
            <el-form-item :label="$t('Warehouse.Driver')">
              <el-select
                v-model="form.driverName"
                :placeholder="!isEdit ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
                :allow-create="true"
                :clearable="true"
                filterable
                @change="driverNameChangeHandler"
              >
                <el-option
                  v-for="(item,index) in driverInfomations"
                  :key="index"
                  :label="item.driverName"
                  :value="item.driverName"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--车牌-->
            <el-form-item :label="$t('SeaExport.TruckNo')">
              <el-input
                v-model="form.plateNumber"
                @input="(val)=>{form.plateNumber = val.trim()}"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!--司机电话-->
            <el-form-item :label="$t('Warehouse.DriverPhone')">
              <el-input v-model="form.driverPhone" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--司机身份证-->
            <el-form-item :label="$t('SeaExport.DriverIDCard')">
              <el-input v-model="form.driverIdCard" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--目的地-->
            <el-form-item :label="$t('CargoMsg.Cargo_Destination')">
              <el-input v-model="form.destination" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--备注-->
            <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
              <el-input v-model="form.remarks" type="textarea" :rows="3" no="remarks" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!--按钮-->
      <div>
        <el-button v-if="isEdit" type="primary" no="showUseCarApplicationFormTabDialog" @click="showUseCarApplicationFormTabDialog">{{ $t('CargoMsg.Cargo_add') }}</el-button>
        <el-button v-if="isEdit" type="danger" no="removeUseCarApplicationForm" @click="removeUseCarApplicationForm">{{ $t('CargoMsg.Cargo_Remove') }}</el-button>
      </div>
      <!--车单绑定的用车申请单-->
      <div class="section grid-wrapper">
        <cargo-ag-grid-wrapper
          config-module="202506073"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="form.useCarApplicationFormVos"
          :show-selected-color="false"
          :check-sub-record="false"
          style="height: 100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
    </div>
    <!--用车申请单 新增成功 弹窗-->
    <el-dialog
      id="newSuccessDialog"
      v-el-drag-dialog
      :visible.sync="newSuccessDialog.visible"
      :title="$t('CargoMsg.Cargo_VehicleOrderGeneratedSuccess')"
      width="500px"
      append-to-body
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="app-main-content"
    >
      <div>
        <i style="color: #409EFF;font-size: medium" class="el-icon-success" />
        <span style="font-size: medium">{{ $t('CargoMsg.Cargo_VehicleOrderSerialNumber') }}</span>
        <span style="color: #5f9ae0;font-size: medium">{{ ' ' + form.carFormNo }}</span>
      </div>
      <div slot="footer">
        <el-button type="primary" no="confirm" @click="toPrint">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
        <el-button type="primary" no="closeAndCopySerialNumber" @click="closeAndCopySerialNumber">{{ $t('CargoMsg.Cargo_CloseAndCopySerialNumber') }}</el-button>
        <el-button no="close" @click="newSuccessDialog.visible = false">{{ $t('common.btn.close') }}</el-button>
      </div>
    </el-dialog>
    <!--用车申请单 弹窗-->
    <el-dialog
      v-if="useCarApplicationFormTabDialog.visible"
      id="useCarApplicationFormTabDialog"
      v-el-drag-dialog
      :visible.sync="useCarApplicationFormTabDialog.visible"
      :title="$t('CargoMsg.Cargo_VehicleRequestForm')"
      width="1500px"
      append-to-body
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="app-main-content"
    >
      <use-car-application-form-tab-list
        ref="useCarApplicationFormTabList"
        :lob="lob"
        :exclude-use-car-application-form-uuids="useCarApplicationFormTabDialog.excludeUseCarApplicationFormUuids"
        source="carFormTabDetail"
      />
      <div slot="footer">
        <el-button type="primary" no="1" @click="addUseCarApplicationForm($refs.useCarApplicationFormTabList.selectedRows)">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="2" @click="useCarApplicationFormTabDialog.visible = false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!--拼装计划 打印 弹窗-->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInputNumber from '@/components/Cargo/Common/cargoInputNumber'
import cargoNumericStepper from '@/components/Cargo/Common/cargoNumericStepper'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import ImportDialog from '@/views/cargo/v0/Information/components/basicData/importDialog.vue'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { Company } from '@/class/model/mdm/Company'
import { carFormDetail, saveCarForm } from '@/api/booking/carForm'
import { deepClone } from '@/utils'
import UseCarApplicationFormTabList from '@/components/Cargo/CarForm/useCarApplicationFormTabList'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'

export default {
  name: 'CarFormTabDetail',
  components: { cargoAgGridWrapper, searchItem, CargoButtonGroupSlider, cargoAdvanceSelect, ImportDialog, AutoNumberInput,
    cargoInputNumber, cargoNumericStepper, cargoTemplateSelectorDialog, UseCarApplicationFormTabList, cargoCompanySelect },
  props: {
    lob: { type: String, default: '' },
    source: { type: String, default: '' }
  },
  data() {
    return {
      ColumnUtils,
      innerVisible: false,
      SystemConstants,
      loading: false,
      TYPE_NAMES,
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        },
        onRowClicked: event => { this.selectedRow = event.data },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VehicleRequestFormNo'),
          field: 'truckOrderNo',
          colId: 'truckOrderNo',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
          field: 'jobNo',
          colId: 'jobNo',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PickUpDelivery'),
          field: 'pickUpDelivery',
          colId: 'pickUpDelivery',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.USE_CAR_APPLICATION_FORM_SOURCES)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'lob',
          colId: 'lob',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Motorcade'),
          field: 'carryingCmp',
          colId: 'carryingCmp',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.AdditionalNotes'),
          field: 'remarks',
          colId: 'remarks',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_MblNo'),
          field: 'mbl',
          colId: 'mbl',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_Customer'),
          field: 'customerId',
          colId: 'customerId',
          width: 180,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
          }
        }, {
          headerName: this.$t('SeaExport.Door'),
          field: 'doorName',
          colId: 'doorName',
          width: 200
        }, {
          headerName: this.$t('SeaExport.DoorAddress'),
          field: 'doorAddr',
          colId: 'doorAddr',
          width: 200
        }, {
          headerName: this.$t('SeaExport.DoorContactPerson'),
          field: 'doorMan',
          colId: 'doorMan',
          width: 150
        }, {
          headerName: this.$t('SeaExport.DoorContactNumber'),
          field: 'doorManTel',
          colId: 'doorManTel',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_EstimatedPickUpDate'),
          field: 'loadingDate',
          colId: 'loadingDate',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          colId: 'quantity',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weight',
          colId: 'weight',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          colId: 'cubage',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Port2'),
          field: 'port',
          colId: 'port',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.portAutoKeyLabelFunc(params.data.port, params.data.lob)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.portAutoKeyLabelFunc(params.data.port, params.data.lob)
          }
        }
      ],
      selectedRows: [],
      gridApi: null,
      isEdit: false, // 是否 编辑
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'CAR_FORM_LIST',
        data: {
          CAR_FORM_UUID_LIST: []
        }
      },
      driverInfomations: [], // 司机 下拉
      form: {},
      originForm: {},
      useCarApplicationFormTabDialog: {
        visible: false,
        excludeUseCarApplicationFormUuids: [] // 排除掉 当前车单中的用车申请单
      },
      newSuccessDialog: {
        visible: false
      }
    }
  },
  computed: {
    // 编辑 权限
    editShow() {
      let show = false
      switch (this.lob) {
        case 'AE':
          show = this.$checkPermission(['button_UseCarApplicationFormTabAE_Edit'])
          break
        default:
      }
      return show
    }
  },
  methods: {
    // 关闭并复制流水号
    closeAndCopySerialNumber() {
      let input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', this.form.carFormNo)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$message.success(this.$t('SeaExport.CopySuccess'))
      }
      document.body.removeChild(input)
      input = null
      this.newSuccessDialog.visible = false
    },
    async init(carFormUuid) {
      if (carFormUuid) {
        // 查看z
        await this.detail(carFormUuid)
      }
      // 初始化 司机下拉列表
      this.driverInfomations = []
      if (this.form.carryingCmp) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.form.carryingCmp)
        if (company) {
          this.driverInfomations = await Company.loadDriverInformation(company.uuid)
        }
      }
      this.$forceUpdate()
    },
    edit() {
      this.form = deepClone(this.originForm)
      this.isEdit = true
      this.selectedRows = []
    },
    cancel() {
      if (!this.form.uuid) {
        this.$emit('cancel')
      }
      this.form = deepClone(this.originForm)
      this.isEdit = false
    },
    // 显示 用车申请单 弹窗
    showUseCarApplicationFormTabDialog() {
      if (this.form.useCarApplicationFormVos && this.form.useCarApplicationFormVos.length > 0) {
        this.useCarApplicationFormTabDialog.excludeUseCarApplicationFormUuids = this.form.useCarApplicationFormVos.map(p => p.uuid)
      }
      this.useCarApplicationFormTabDialog.visible = true
      this.useCarApplicationFormTabDialog.visible = true
    },
    // 加入 用车申请单
    addUseCarApplicationForm(list) {
      this.form.useCarApplicationFormVos = [...this.form.useCarApplicationFormVos, ...list]
      this.useCarApplicationFormTabDialog.visible = false
    },
    // 移除 用车申请单
    removeUseCarApplicationForm() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      if (this.selectedRows.length === this.form.useCarApplicationFormVos.length) {
        this.$message.warning(this.$t('SeaExport.KeepLeastOneDetail'))
        return
      }
      // 记住 删除的 用车申请单
      if (this.form.removeUseCarApplicationFormVos) {
        this.form.removeUseCarApplicationFormVos = [...this.form.removeUseCarApplicationFormVos, ...(this.selectedRows.filter(p => !!p.carFormUuid))]
      } else {
        this.form.removeUseCarApplicationFormVos = [...(this.selectedRows.filter(p => !!p.carFormUuid))]
      }
      const removeUseCarApplicationFormUuids = this.selectedRows.map(p => p.uuid)
      // 刷新 用车申请单 列表
      this.form.useCarApplicationFormVos = this.form.useCarApplicationFormVos
        .filter(p => removeUseCarApplicationFormUuids.indexOf(p.uuid) === -1)
      this.selectedRows = []
    },
    // 车单详情
    async detail(carFormUuid) {
      this.loading = getLoading4Cxt()
      this.form.branchId = this.$store.getters.currentOfficeId
      await carFormDetail({ uuid: carFormUuid }).then(res => {
        this.form = res.data
        this.originForm = deepClone(res.data)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 保存车单
    save() {
      this.loading = getLoading4Cxt()
      this.form.branchId = this.$store.getters.currentOfficeId
      const isNew = !this.form.uuid
      if (!this.form.removeUseCarApplicationFormVos) {
        this.form.removeUseCarApplicationFormVos = []
      }
      saveCarForm(this.form).then(res => {
        this.form = res.data
        this.originForm = deepClone(res.data)
        this.isEdit = false
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        if (isNew) {
          this.newSuccessDialog.visible = true
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 司机 变更处理
    driverNameChangeHandler() {
      if (this.form.driverName) {
        if (this.driverInfomations && this.driverInfomations.length > 0) {
          const driver = this.driverInfomations.find(p => p.driverName === this.form.driverName)
          if (driver) {
            this.form.driverPhone = driver.driverPhone
            this.form.plateNumber = driver.plateNumber
            this.form.driverIdCard = driver.driverIdCard
          }
        }
      }
    },
    // 车队 变更处理
    async carryingCmpChangeHandler() {
      this.driverInfomations = []
      this.form.driverName = ''
      this.form.driverPhone = ''
      this.form.plateNumber = ''
      this.form.driverIdCard = ''
      if (this.form.carryingCmp) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.form.carryingCmp)
        if (company) {
          this.driverInfomations = await Company.loadDriverInformation(company.uuid)
          if (this.driverInfomations && this.driverInfomations.length > 0) {
            let driver = this.driverInfomations.find(p => p.defaultDriver)
            if (!driver) {
              driver = this.driverInfomations[0]
            }
            this.form.driverName = driver.driverName
            this.form.driverPhone = driver.driverPhone
            this.form.plateNumber = driver.plateNumber
            this.form.driverIdCard = driver.driverIdCard
          }
        }
      }
    },
    // 打印按钮触发事件
    toPrint() {
      this.templateSelectorDialog.data.CAR_FORM_UUID_LIST = [this.form.uuid]
      this.templateSelectorDialog.visible = true
    }
  }
}
</script>

<style scoped lang="scss">
.input-label {
  display: inline-block;
  width: 60px;
  color: #666666;
}
.car-form-detail-form .lable-blue ::v-deep {
  .el-form-item__label {
    color: blue !important;
  }
}
.car-form-detail-form .el-form-item {
  margin-left: 20px;
}
.el-form{
  /deep/ .el-input__inner{
    //width: 300px;
  }
}
</style>
